import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import AgeConfirmation from "@/components/AgeConfirmation";

/**
 * AppShell — mobile-first container with bottom nav.
 * Keeps the four primary destinations stable across the app.
 */
export default function AppShell() {
  const location = useLocation();
  // Hide bottom navigation only while the user is in a focused, linear flow.
  const path = location.pathname;
  const hideNav =
    path.startsWith("/check-in") ||
    path.startsWith("/results") ||
    path.startsWith("/practices");
  const showNav = !hideNav;

  // Auto-scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <AgeConfirmation>
    <div className="App un-shell">
      <main
        className={`min-h-screen w-full ${showNav ? "pb-24" : ""} un-safe-top`}
        style={{ background: "transparent" }}
      >
        <Outlet />
      </main>
      {showNav && <BottomNav />}
    </div>
    </AgeConfirmation>
  );
}
